import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    handleError(error: any) {
        console.error('GLOBAL_ERROR_TRAPPED:', error);
        // Never show alert for known cases (401, or CCP postMessage when dialer closed / sidenav change)
        const msg = (error?.message || error || '').toString();
        if (msg.includes('401') || msg.includes('Unauthorized') || msg.includes('Http failure response')) {
            return;
        }
        if (msg.includes('postMessage') && msg.includes('null')) {
            return; // CCP iframe communication when dialer closed or sidenav changed
        }
        throw error;
    }
}
